import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom";
import * as serviceworker from "./serviceWorker";
import App from "./App";
import "./styles/global.css";

window.Buffer = Buffer;

ReactDOM.render(
	<App />,
	document.getElementById("root"),
	() => {
		window.finishProgress();
	}
);

serviceworker.unregister();
